import { InvestmentObjectivesSetData } from '@interfaces/models';
import { INVESTMENT_OBJECTIVE_LABELS } from '@interfaces/models/investment-objectives.enum';
import { IKeyLabelPair } from '@interfaces/models/open-account-mfes/mfe-common.interfaces';
import { createSelector } from '@ngrx/store';
import { InvestmentObjectivesState } from '@store/reducers/investment-objectives/investment-objectives.reducer';
import { selectCurrentTransactionInvestmentObjectives } from '@store/selectors/transaction-state/transaction-state.selectors';

import * as fromFeature from '../../reducers/index';

export const selectInvestmentObjectivesState = createSelector(
  fromFeature.getInvestmentObjectivesState,
  (state: InvestmentObjectivesState) => state,
);

/**
 * Primitive slices
 */

export const selectObjectives = createSelector(
  selectInvestmentObjectivesState,
  selectCurrentTransactionInvestmentObjectives,
  (state, transactionObjectives) => {
    // current transaction objectives could be set for multi-inheritance flow
    // and only if current transaction exists, otherwise it is null
    return transactionObjectives ? transactionObjectives : state.objectives;
  },
);

export const selectObjectiveStatus = createSelector(
  selectInvestmentObjectivesState,
  (s) => s.objectivesStatus,
);

export const selectInvestmentObjectives = createSelector(selectObjectives, (objectives) => ({
  objectives,
}));

export const selectSelectedKeys = createSelector(selectObjectives, (obj) =>
  obj
    ? Object.entries(obj)
        .filter(([, v]) => v === true)
        .map(([k]) => k)
    : [],
);

const keyToLabel = (key: string): string =>
  (INVESTMENT_OBJECTIVE_LABELS as Record<string, string>)[key] ?? '';

export const selectSelectedPairs = createSelector(selectSelectedKeys, (keys): IKeyLabelPair[] =>
  keys.map((k) => ({ key: k, label: keyToLabel(k) })),
);

export const selectSetData = createSelector(
  selectSelectedPairs,
  selectObjectiveStatus,
  (selected, isValid): InvestmentObjectivesSetData => ({
    runValidation: !isValid,
    errorText: 'This field is required.',
    selectedObjectives: selected,
  }),
);

export const selectConcatenatedLabels = createSelector(selectSelectedKeys, (keys) => keys);
